import axios from "axios";
import {
  Api_AccountStatement,
  API_CapitalGainStatementDownload,
  Api_Case_Create,
  APi_CMS_ErrorDetails,
  APi_CMS_GetHamburgerMenu,
  APi_CMS_IntegrationVariables,
  APi_CMS_PageVariables,
  Api_Create_Case_Query,
  Api_Create_Case_Query_Multiple,
  Api_Create_Order,
  Api_Createcase,
  Api_CrmCaseCreate,
  Api_Customer_Info,
  Api_Dataservice,
  Api_DelinkFolioList,
  Api_DownloadCapitalStatement,
  API_DownloadContractNote,
  Api_DownloadECard,
  APi_DownloadPolicyAccountStatement,
  Api_DownloadPolicyDocs,
  Api_DownloadPolicyWording,
  Api_DownloadPremium_Receipt,
  API_DownloadStatementOfAccount,
  API_DownloadStatementOfTransaction,
  Api_DownloadTaxCertificate,
  Api_ExcessRefundAmount,
  Api_ExitLoad,
  Api_FetchBondPolicy,
  Api_FetchConsent,
  Api_FetchDashboardDetails,
  Api_FetchFundDetails,
  Api_Fetchlan,
  Api_FetchLiCaseQueryCrm,
  Api_FetchNSDLPANDetails,
  Api_FetchPastPaymentDetails,
  Api_FetchPolBankDetails,
  Api_FetchPolicyAllDetails,
  Api_FetchPolicyDetails,
  Api_FetchPolicyDetailsByMobileNumber,
  API_FetchPortfolio,
  Api_FetchPremium_Receipt_WithDate,
  Api_FetchProfile_Details,
  Api_FetchRecentUpdates,
  Api_FetchUserProductStatus,
  Api_FolioLinkingDelinking,
  APi_FolioSchemeSummary,
  Api_FoliosSummary,
  Api_GenerateInternalToken,
  Api_GenerateOtp,
  Api_GenerateSso_New,
  Api_GenerateSso_Old,
  Api_GetCustomerLobDetails,
  API_HL_SuccessMessages,
  Api_LiGetBankName,
  Api_LiGetOtp,
  Api_LiKarzaBankAccount,
  Api_LiNpsZoneDetails,
  Api_LiSaveNpsFeedback,
  Api_LiSetAlertExisting,
  Api_LiUploadDoc,
  Api_LiValidateOtp,
  Api_LiWhatsappOptIn,
  Api_LmsLeadRedirection,
  Api_LogOut,
  Api_Order_Status,
  Api_PolicyInsured,
  Api_RateUs,
  Api_ReportingService,
  Api_SendEmail,
  Api_SendWhatsApp,
  Api_UpdateHIDetails,
  Api_ValidateOtp,
  Api_ValidatePan,
  Api_ValidateSso_New,
  Api_ValidateSso_Old,
  Api_WelcomeKitService,
  Api_WhatsappOpt,
  HomeLoanIdentifier,
  Api_TeraDataUserRegistration,
  Api_SaveHoldings,
  Api_SaveUiException,
  Api_Sfdc_Case_Create,
  Api_UnifiedOfferDetails,
} from "../utils/ApiEndpoints";
import {
  decryptString,
  encryptString,
  getStaticReqPayload,
} from "../utils/helper";
import {
  DEVICE_TYPE,
  USE_DEV_TEST_DATA,
  staticReqPayloadApis,
} from "../utils/constants";
import {
  E_CampaignIdentifierKeys,
  E_ChannelOptions,
  T_CampaignHeaders,
} from "../globalTypes/GlobalTypes";
import CsSessionStorageUtils from "../utils/CsSessionStorageUtils";
import { request } from "http";
import CsLocalStorageUtils from "../utils/CsLocalStorageUtils";
import { isEmpty } from "lodash";

let store: any = undefined;

const encryptedResponseAPIList = [
  // Api_ValidateSso_New,
  // Api_GenerateSso_New,
  // Api_GenerateSso_Old,
  // Api_ValidateSso_Old,
  Api_GetCustomerLobDetails,
  Api_FetchConsent,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_FetchPolicyDetails,
  Api_FetchDashboardDetails,
  Api_LiKarzaBankAccount,
  Api_LiUploadDoc,
  Api_FetchNSDLPANDetails,
  Api_DownloadTaxCertificate,
  // Api_FetchProfile_Details,
  Api_FetchPremium_Receipt_WithDate,
  HomeLoanIdentifier,

  // Api_ValidatePan,
  // APi_FolioSchemeSummary,
  // Api_DelinkFolioList,
  // Api_AccountStatement,
  // Api_FetchPolicyDetailsByMobileNumber,
  // // Api_ExitLoad,
  // APi_CMS_GetHamburgerMenu,
  // APi_CMS_IntegrationVariables,
  // APi_CMS_PageVariables,
  // API_FetchPortfolio,
  // Api_PolicyInsured,
  // Api_DownloadPolicyWording,

  Api_FetchPolicyAllDetails,
  Api_FetchPolicyDetails,
  Api_FetchProfile_Details,
  Api_ValidatePan,
  APi_FolioSchemeSummary,
  Api_AccountStatement,
  Api_FetchPolicyDetailsByMobileNumber,
  APi_CMS_GetHamburgerMenu,
  APi_CMS_IntegrationVariables,
  // APi_CMS_PageVariables,commented for ASP-3487 fix
  Api_LiNpsZoneDetails,
  Api_FetchPolBankDetails,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_Customer_Info,
  Api_TeraDataUserRegistration,
  Api_DelinkFolioList,
  Api_GenerateSso_Old,
  Api_PolicyInsured,
  Api_UnifiedOfferDetails
];

const encryptedRequestAPIList = [
  // Api_ValidateSso_New,
  // Api_GenerateSso_New,
  // Api_GenerateSso_Old,
  // Api_ValidateSso_Old,
  Api_FetchConsent,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_GetCustomerLobDetails,
  // Api_FetchProfile_Details,
  // Api_LogOut,
  Api_LmsLeadRedirection,

  //LI
  Api_FetchPolicyAllDetails,
  Api_FetchDashboardDetails,
  Api_DownloadTaxCertificate,
  Api_FetchPolicyDetails,
  Api_FetchRecentUpdates,
  Api_LiGetOtp,
  Api_LiValidateOtp,
  Api_LiGetBankName,
  Api_CrmCaseCreate,
  Api_WhatsappOpt,
  Api_LiWhatsappOptIn,
  // Api_DownloadPremium_Receipt,
  APi_DownloadPolicyAccountStatement,
  Api_LiKarzaBankAccount,
  Api_FetchBondPolicy,
  Api_FetchPolBankDetails,
  Api_FetchFundDetails,
  Api_LiNpsZoneDetails,
  Api_LiSaveNpsFeedback,
  Api_LiSetAlertExisting,
  Api_LiUploadDoc,
  Api_FetchNSDLPANDetails,
  Api_FetchLiCaseQueryCrm,
  Api_FetchPremium_Receipt_WithDate,
  HomeLoanIdentifier,
  //MF and Stocks
  // Api_DownloadCapitalStatement,
  // Api_FoliosSummary,
  // APi_FolioSchemeSummary,
  // Api_ValidatePan,
  // API_FetchPortfolio,
  // Api_FolioLinkingDelinking,
  // Api_DelinkFolioList,
  // API_DownloadStatementOfTransaction,
  // API_DownloadContractNote,
  // API_DownloadStatementOfAccount,
  // API_CapitalGainStatementDownload,
  //HL
  Api_Dataservice,
  Api_Fetchlan,
  Api_Createcase,
  Api_ExcessRefundAmount,
  Api_ReportingService,
  Api_WelcomeKitService,
  Api_Case_Create,
  Api_Create_Order,
  Api_Order_Status,
  Api_Create_Case_Query,
  Api_Create_Case_Query_Multiple,
  //HI
  // Api_FetchPolicyDetailsByMobileNumber,
  // Api_PolicyInsured,
  // Api_DownloadECard,
  // Api_DownloadPolicyDocs,
  // Api_DownloadPolicyWording,
  // Api_UpdateHIDetails,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_Customer_Info,
  Api_FetchUserProductStatus,
  Api_TeraDataUserRegistration,
  Api_SaveHoldings,
  Api_SaveUiException,
  Api_DelinkFolioList,
  Api_GenerateSso_Old,
  Api_PolicyInsured,
  Api_Sfdc_Case_Create,
  Api_UnifiedOfferDetails
];

export const injectStore = (_store: any) => {
  store = _store;
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|ipod|android|windows phone/g.test(userAgent);
  const isPWA = window.matchMedia("(display-mode: standalone)").matches;
  let temp = DEVICE_TYPE.WEB;
  if (isPWA) {
    if (isMobile) {
      temp = DEVICE_TYPE.PWA_MOBILE;
    } else {
      temp = DEVICE_TYPE.PWA_WEB;
    }
  } else if (isMobile) {
    if (isEmpty(store.getState()?.CsAppSlice?.NativeDeviceInfo)) {
      temp = DEVICE_TYPE.ABC_WEB_MOB_CS; //Mobile Web
    } else {
      temp = DEVICE_TYPE.MOBILE; //Mobile Native
    }
  } else {
    temp = DEVICE_TYPE.WEB;
  }
  return temp;
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    // Add any other headers or configurations you need
  },
});

const testDataUrls = ["/abfssl/fetch-customer-and-lob-details"];

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // You can modify the request config here, e.g., add authentication headers
    if (window.location.hostname.startsWith("localhost")) {
      if (
        USE_DEV_TEST_DATA &&
        staticReqPayloadApis.includes(config?.url || "")
      ) {
        config.data = getStaticReqPayload(config);
      }
    }
    // Encryption logic for request payload
    if (encryptedRequestAPIList.includes(config.url || "")) {
      const configuration =
        store.getState()?.CsAppSlice.tokenDetails?.configuration;
      const IV = configuration?.iv || "";
      const secretKey = configuration?.key || "";

      if (config.data && Object.keys(config.data).length) {
        const requestDataString = JSON.stringify(config.data); // Convert request data to string
        const encryptedRequest = encryptString(
          requestDataString,
          IV,
          secretKey
        ); // Encrypt the request data
        config.data = { request: encryptedRequest }; // Replace the original data with the encrypted one
      }
    }
    let externalToken = undefined;
    let internalToken = undefined;
    let source = undefined;
    let csUserId = undefined;
    let traceId = undefined;
    let loginSource = undefined;
    let browserVersion = undefined;
    let browserName = undefined;
    let channel = undefined;
    let nativeDeviceInfo = undefined;
    let ipAddress = undefined;

    try {
      const csAppSlice = store.getState()?.CsAppSlice;
      nativeDeviceInfo = csAppSlice?.NativeDeviceInfo;
      ipAddress = csAppSlice?.ipAddress;
      browserName = csAppSlice.userAgent?.browserName;
      browserVersion = csAppSlice.userAgent?.browserVersion;
      externalToken = csAppSlice.tokenDetails?.external?.access_token;
      internalToken = csAppSlice.tokenDetails?.internal?.authToken;
      source = CsSessionStorageUtils.get("DEVICE_TYPE") || getDeviceType();
      traceId = CsSessionStorageUtils.get("TRACE_ID") || csAppSlice.traceId;
      channel = store.getState()?.CsAppSlice.channel;
      loginSource =
        csAppSlice.channel === E_ChannelOptions.ONE_ABC
          ? "11"
          : csAppSlice.channel === E_ChannelOptions.SUPER_APP
            ? "25"
            : "26";
      csUserId = csAppSlice.csUserId || csAppSlice.userDetails.CS_USER_ID;
    } catch (err) { }
    if (
      [Api_GenerateSso_New, Api_GenerateSso_Old].includes(config?.url || "")
    ) {
      config.headers["cognito-token "] = `Bearer ${externalToken}`;
    } else if (
      [Api_ValidateSso_New, Api_ValidateSso_Old].includes(config?.url || "")
    ) {
      config.headers["cognito-token "] = `Bearer ${externalToken}`;
    } else if (config.url !== "/auth/generate-token") {
      config.headers["authToken"] = externalToken;
      config.headers["Authorization"] = `Bearer ${internalToken}`;
    }
    if (channel === E_ChannelOptions.SECONDARY_CHANNEL) {
      /**
       * to add utm related headers in case of secondary channels
       */
      const campaignIdentifiers: T_CampaignHeaders[] = JSON.parse(
        CsSessionStorageUtils.get("CAMPAIGN_IDENTIFIERS")
      );
      campaignIdentifiers?.forEach((obj: T_CampaignHeaders) => {
        config.headers[obj.key] = obj.value;
      });
    }
    if (config.url === Api_GenerateInternalToken) {
      if (!isEmpty(nativeDeviceInfo)) {
        const mobileModel = nativeDeviceInfo?.deviceName;
        const mobileMakeModel = nativeDeviceInfo?.deviceModel;
        const mobileOs = nativeDeviceInfo?.systemName;
        const mobileOsVersion = nativeDeviceInfo?.systemVersion;
        const deviceId = nativeDeviceInfo?.identifier;
        const appVersion = nativeDeviceInfo?.appVersion;
        config.headers["mobileModel"] = mobileModel;
        config.headers["mobileMakeModel"] = mobileMakeModel;
        config.headers["mobileOs"] = mobileOs;
        config.headers["mobileOsVersion"] = mobileOsVersion;
        config.headers["deviceId"] = deviceId;
        config.headers["appVersion"] = appVersion;
      }
      config.headers["ipAddress"] = ipAddress;
    }
    if (isEmpty(nativeDeviceInfo)) {
      config.headers["browser"] = browserName;
      config.headers["browserVersion"] = browserVersion;
    }
    config.headers["csUserId"] = csUserId;
    config.headers["source"] = source;
    config.headers["loginSource"] = loginSource;
    config.headers["traceId"] = traceId;
    config.headers["pageName"] = window.location.pathname;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // You can modify the response data here, e.g., handling pagination
    if (encryptedResponseAPIList.includes(response.config.url || "")) {
      const configuration =
        store.getState()?.CsAppSlice.tokenDetails?.configuration;
      const IV = configuration?.iv || "";
      const secretKey = configuration?.key || "";
      let decryptWholeResponse = false;
      if (
        [Api_ValidateOtp, Api_GenerateOtp].includes(response.config.url || "")
      ) {
        decryptWholeResponse = true;
      }
      const decryptedResponse = decryptString(
        decryptWholeResponse ? response.data : response.data.payload,
        IV,
        secretKey
      );
      let transformedResponse = decryptedResponse;
      if (decryptedResponse) {
        transformedResponse = JSON.parse(decryptedResponse);
      }
      if (decryptWholeResponse) {
        response.data = transformedResponse;
      } else {
        response.data.payload = transformedResponse;
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
